import styled from 'styled-components';

export const VestingTermsFormStyles = styled.div`
	display: flex;
	gap: 0.5rem;
	padding-bottom: 2.5rem;

	.col {
		flex: 1;
	}
`;

export const VestingSharedStyles = styled.div`
	.inner {
		margin-top: 1rem;
	}

	.percentage-row {
		margin-bottom: 1rem;
		border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		padding-bottom: 1rem;
	}

	.percentage-input {
		max-width: 120px;
	}
`;
